import React, { useState } from "react";
import CryptoJS from "crypto-js";
import { JUMPS_REDIRECT_URL } from "../../Config/urls";

const EncryptDecryptToken = () => {
  const token = sessionStorage.getItem("Token");
  const policy_status = sessionStorage.getItem("policy_status");
  const user_name = sessionStorage.getItem("user_name");
  

  const encryptToken = () => {
    const secretKey = "SMdOeHhaI@4T)$eDPOZ^(X2"; // Replace with your secret key
    const expirationDate = new Date();
    expirationDate.setSeconds(expirationDate.getSeconds() + 10); // Token expires in 10 seconds
    const tokenData = {
      token,
      policy_status,
      user_name,
      expiration: expirationDate.toISOString(),
    };
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(tokenData),
      secretKey
    ).toString();
      window.open(`${JUMPS_REDIRECT_URL}?token=${encodeURIComponent(encrypted)}`, '_blank');
  };

  return (
    <div>
      <div style={{ cursor: "pointer" }} onClick={encryptToken}>
        Jump S
      </div>
    </div>
  );
};

export default EncryptDecryptToken;

